intra_module.factory('Event', function($resource, api_url, modules_url) {
    const url    = `${api_url}/students/:login/events`;
    const params =
        {login: '@login'};
    const actions = {
        get: {
            method: 'GET',
            isArray: true,
            url:    `${url}`
        },

        getEventForActivity: {
            method: 'GET',
            isArray: true,
            url:    `${api_url}/sessions/:session_id/activities/:activity_id/students/:login/events?free_slots=false`,
            params: {
                session_id:  '@session_id',
                activity_id: '@activity_id'
            }
        },

        getGroupSelectedEvent: {
            method: 'GET',
            isArray: true,
            url: `${api_url}/students/:login/events/:event_date/group-events`,
            params: {
                login: '@login',
                event_date: '@event_date'
            }
        }
    };

    return $resource(url, params, actions);
});
